import { gql } from '@apollo/client';
import { CARD_WITH_BLOCKS } from '../card';
import { IMAGE_BLOCK } from '../image';
import { CONTENT_BLOCK } from '../content';

export const SLIDER_WITH_BLOCKS = gql`
  fragment SliderWithBlocksFragment on SliderWithBlocks {
    slidesToShow {
      desktop
      tablet
      mobile
    }
    type
    paginationType
    autoScrollEnabled
    autoScrollSpeed
    sliderWithBlocks: blocks {
      ...CardWithBlocksFragment
      ...ImageBlockFragment
      ...ContentBlockFragment
    }
    id
    blockName
    blockType
  }
  ${CARD_WITH_BLOCKS}
  ${IMAGE_BLOCK}
  ${CONTENT_BLOCK}
`;
